<template>
  <page-layout :title="pageTitle">
    <md-card class="mt-10">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("zoom_meeting.general_info") }}</h4>
        </div>
      </md-card-header>
      <md-card-content class="ml-10 px-0">
        <general-info :data="generalInfo"></general-info>
      </md-card-content>
    </md-card>
    <IsisDropdownInfinity
      v-if="!isScheduleMeeting && initCpmDropdown"
      :options="listDate"
      @fetchMoreOptions="fetchMoreDate"
      :selected-value-props="dateSelected.id"
      :displayValue="dateSelected.name"
      label="common.date"
      @updateValueSelected="newDateSelect = $event"
      class="w-[400px] ml-auto pb-1"
    ></IsisDropdownInfinity>
    <md-card class="mt-10">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">
            {{ $t("zoom_meeting.report_statistics") }}
          </h4>
        </div>
      </md-card-header>
      <md-card-content class="pl-5">
        <Statistic :staticInfo="staticInfo"></Statistic>
        <p class="text-[18px] font-medium  pt-5">
          {{ $t("zoom_meeting.attendance_log") }}
        </p>
        <AttendanceLog
          :data="attendanceLogInfo"
          :defaultData="attendanceLogInfoDefault"
          :date-selected="dateSelected.id"
          :startDate="startDate"
          :currentTimezone="currentTimezone"
          :staticInfo="staticInfo"
          :fromTimeSelected="fromTimeSelected"
          :isScheduleMeeting="isScheduleMeeting"
        ></AttendanceLog>
      </md-card-content>
    </md-card>
  </page-layout>
</template>
<script>
import Statistic from "./Statistic";
import { service_names } from "@/constants/Services";
import AttendanceLog from "../../Components/AttendanceLog";
import pick from "lodash/pick";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import GeneralInfo from "./GeneralInfo";
import PageLayout from "../../../PageLayout";
import IsisDropdownInfinity from "@/components/Base/IsisDropdownInfinity";
import {
  convertDateSendServer,
  convertTimeByTimezone,
  formatDateClient
} from "../../../../helpers/datetime-helper";

export default {
  components: {
    PageLayout,
    Statistic,
    AttendanceLog,
    GeneralInfo,
    IsisDropdownInfinity
  },
  data() {
    return {
      staticInfo: null,
      attendanceLogInfo: null,
      attendanceLogInfoDefault: null,
      generalInfo: {},
      listDate: [],
      limitListDate: 1000,
      dateTimeSelected: "",
      dateSelected: {
        name: "",
        id: ""
      },
      startDate: "",
      fromTimeSelected: "",
      newDateSelect: "",
      currentTimezone: "",
      initCpmDropdown: false,
      isScheduleMeeting: false,
      isoFormat: "YYYY-MM-DD[T]HH:mm:ss",
      serverFormat: "YYYY-MM-DD HH:mm:ss",
      buttonSearch: {
        action: this.fetchAttendanceLog
      },
      cpmKey: null,
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 1,
        hidePaging: false,
        hidePerPageOptions: false
      },
      formatDateClient
    };
  },
  computed: {
    zoomId() {
      return this.$route.params.id;
    },
    pageTitle() {
      return (
        this.$t("zoom_meeting.report_participant") + this.generalInfo.title
      );
    }
  },
  watch: {
    newDateSelect: function(newDate) {
      this.dateSelected = Object.assign(
        {},
        {
          name: newDate,
          id: newDate
        }
      );
      if (!this.isScheduleMeeting) {
        this.startDate = this.listDate.find(
          item => item.id === newDate
        ).startDate;
        const startDateTime = this.listDate.find(item => item.id === newDate)
          .startDate;
        this.dateTimeSelected = moment(startDateTime, this.isoFormat).format(
          "YYYY-MM-DD HH:mm"
        );
      } else {
        this.dateTimeSelected = convertTimeByTimezone(
          newDate + " " + this.fromTimeSelected,
          this.currentTimezone,
          "Etc/UTC",
          "YYYY-MM-DD HH:mm"
        );
      }
      this.fetchReportByDateTime();
    }
  },
  created() {
    this.fetchGeneralInfo();
  },
  methods: {
    fetchReportByDateTime() {
      this.fetchReportStatic({
        date: this.dateTimeSelected
      });
      this.fetchAttendanceLog({
        limit: 1000,
        date: this.dateTimeSelected
      });
    },
    async fetchGeneralInfo() {
      const path = `${service_names.school}/zoom-meeting/${this.zoomId}`;
      const { data } = await this.$axios.get(path);
      this.generalInfo = cloneDeep(data);
      this.currentTimezone = this.generalInfo.timezone;
      this.isScheduleMeeting = data.zoom_meeting_type === "A schedule meeting";
      if (this.isScheduleMeeting) {
        this.newDateSelect = data.start;
        this.fromTimeSelected = data.from_time;
        return;
      }
      await this.fetchListDate();
    },
    formatTableData(data) {
      return data.map(item => {
        return {
          ...item,
          join_time: convertTimeByTimezone(
            item.join_time,
            "Etc/UTC",
            this.currentTimezone,
            this.serverFormat
          ),
          leave_time: convertTimeByTimezone(
            item.leave_time,
            "Etc/UTC",
            this.currentTimezone,
            this.serverFormat
          )
        };
      });
    },
    async fetchReportStatic(params) {
      const path = `${service_names.school}/report-zoom-meeting/${this.zoomId}/report-statistics`;
      const { data } = await this.$axios.get(path, { ...params } || {});
      this.staticInfo = data;
    },
    async fetchAttendanceLog(params) {
      const path = `${service_names.school}/report-zoom-meeting/${this.zoomId}/attendance-log`;
      const { data } = await this.$axios.get(path, { ...params });
      this.attendanceLogInfo = null;
      this.attendanceLogInfoDefault = null;
      if (!data.data.length) return;
      this.setAttendanceLog(cloneDeep(data.data));
    },
    setAttendanceLog(data) {
      const getTime12Hour = date => {
        if (!date) return "";
        return moment(date, this.serverFormat).format("HH:mm");
      };
      let baseData = this.formatTableData(data);
      let info = baseData.map(item => {
        return {
          ...pick(item, [
            "calendar_id",
            "description",
            "date",
            "join_time",
            "leave_time",
            "id",
            "status",
            "participant_display_name",
            "class"
          ]),
          ...pick(item?.user_no_sql, [
            "full_name",
            "student_code",
            "avatar_url",
            "email"
          ]),
          from_join_time: getTime12Hour(item.join_time),
          date_join_time: moment(item.join_time).format("YYYY-MM-DD"),
          from_leave_time: getTime12Hour(item.leave_time),
          date_leave_time: moment(item.leave_time).format("YYYY-MM-DD")
        };
      });
      this.attendanceLogInfo = cloneDeep(info);
      this.attendanceLogInfoDefault = cloneDeep(info);
    },
    async fetchListDate() {
      const path = `${service_names.school}/report-zoom-meeting/${this.zoomId}/calendar/date`;
      const { data } = await this.$axios.get(
        path,
        {
          limit: this.limitListDate
        },
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      this.fromTimeSelected =
        moment(data?.data[0]?.date, this.isoFormat).format("HH:mm") || "";
      this.listDate = data.data?.map(item => {
        return {
          name: this.convertTimezone(item.date, item.timezone),
          id: this.convertTimezone(item.date, item.timezone),
          startDate: item.date
        };
      });
      this.dateSelected = Object.assign(
        {},
        {
          name: this.listDate[0].name,
          id: this.listDate[0].id
        }
      );
      this.newDateSelect = this.listDate[0].id;
      this.initCpmDropdown = true;
    },
    convertISOtime(time) {
      return moment(time, this.isoFormat).format(this.serverFormat);
    },
    convertTimezone(time, zone) {
      const timeUTC = this.convertISOtime(time);
      const moment = require("moment-timezone");
      if (!timeUTC) return "";
      const timezoneConverted = moment(
        timeUTC + " ZZ",
        this.serverFormat + " ZZ"
      )
        .tz(zone)
        .format(this.serverFormat);
      return this.formatTimezoneToClient(timezoneConverted);
    },
    formatTimezoneToClient(time) {
      return moment(time, this.serverFormat).format(this.formatDateClient);
    },
    fetchMoreDate() {
      this.limitListDate += 10;
      this.fetchListDate();
    }
  },
  provide() {
    return {
      fetchReportStatic: this.fetchReportStatic,
      fetchReportByDateTime: this.fetchReportByDateTime
    };
  }
};
</script>
